export const importLayer = {
  LAYER_IMPORT_STARTED: 'LAYER_IMPORT_STARTED',
  LAYER_IMPORT_DONE: 'LAYER_IMPORT_DONE',
  LAYER_IMPORT_ERROR: 'LAYER_IMPORT_ERROR',
};
